import { isMapLoaded } from '../../stores/store';
import {get} from "svelte/store";

export function onMapReady() {
    return new Promise((resolve, reject) => {
        if (get(isMapLoaded)) {
            resolve('map loaded');
        } else {
            let wait4load = setInterval(() => {
                if (get(isMapLoaded)) {
                    clearInterval(wait4load);
                    resolve('map loaded');
                }
            }, 230)
        }
    });
}